<div class="breadcrumbs-wrapper">
  @if (rootLabel()) {
    <nav class="breadcrumbs-trail" aria-label="Breadcrumb">
      <ol class="breadcrumbs-list">
        <li class="breadcrumbs-item">
          <span class="breadcrumbs-root">{{ rootLabel() }}</span>
        </li>

        @if (moduleLabel(); as module) {
          <li class="breadcrumbs-item">
            <span class="breadcrumbs-module">{{ module }}</span>
          </li>
        }

        @for (item of breadcrumbs(); track item.label + (item.route || "")) {
          <li class="breadcrumbs-item">
            <svg
              class="breadcrumbs-chevron"
              viewBox="0 0 6 10"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M0.907 0L0 0.873 4.186 5 0 9.127 0.907 10 6 5z"></path>
            </svg>

            <button
              type="button"
              [class.breadcrumbs-link]="item.isClickable"
              [class.breadcrumbs-current]="!item.isClickable"
              [disabled]="!item.isClickable"
              [attr.aria-current]="item.isCurrent ? 'page' : null"
              [attr.aria-label]="item.label"
              (click)="onBreadcrumbClick(item)"
            >
              {{ item.label }}
            </button>
          </li>
        }
      </ol>
    </nav>
  }

  @if (showManageContent()) {
    <button
      mat-stroked-button
      class="manage-content-btn"
      (click)="onManagePageContent()"
      type="button"
      aria-label="Manage page content"
    >
      <mat-icon
        class="manage-content-btn-icon material-icons-outlined"
        aria-hidden="true"
      >
        move_down
      </mat-icon>
      <span class="button-text">
        {{ translations.breadcrumbs.managePageContent }}
      </span>
    </button>
  }
</div>
